import axios from 'axios'
import {config} from './Constants'

export const api = {
    fetchRound,
    roundResult,
    fetchWord,
    speech,
    sendMessage,
    getAllMessages,
    getUserMessages,
    fetchAnalizeResult,
    transcription,
    createSpeakingSession,
    getActiveSpeakingSession,
    getSpeakingMessages,
    resetSpeakingSession,
    sendSpeakingTurn,
    signIn,
    signUp,
    fetchGrammarRound,
    fetchGrammarLesson,
    grammarRoundResult,
    transcribeGrammarExercise,
    checkGrammarSituation,
    isValidResponse,
    fetchWritingRoles,
    fetchUser,
    changeLevel,
    logout,
    getRemindingWords,
    smartCheck,
    writingSmartCheck,
    saveMessages,
    fetchSummaryStatistics,
    fetchVocabularyStatistics,
    fetchGrammarStatistics,
    fetchWritingStatistics,
    fetchWaitTime
}

const instance = axios.create({
    baseURL: config.url.API_BASE_URL,
    withCredentials: true
})

async function fetchSummaryStatistics(navigate, showNotification) {
    try {
        return await instance.get('/statistics/summary');
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function fetchVocabularyStatistics(navigate, showNotification) {
    try {
        return await instance.get('/vocabulary/statistics');
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function fetchGrammarStatistics(navigate, showNotification) {
    try {
        return await instance.get('/grammar/statistics');
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function fetchWritingStatistics(navigate, showNotification) {
    try {
        return await instance.get('/writing/statistics');
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function fetchRound(navigate, showNotification) {
    try {
        return await instance.get('/vocabulary/round');
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function fetchUser(navigate, showNotification) {
    try {
        return await instance.get('/user');
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function changeLevel(data, navigate, showNotification) {
    try {
        return await instance.put('/user/level', data, {
            headers: {
                'Content-type': 'application/json'
            }
        });
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function fetchGrammarRound(navigate, showNotification) {
    try {
        return await instance.get('/grammar/round');
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function fetchGrammarLesson(planId, navigate, showNotification) {
    try {
        return await instance.get(`/grammar/plans/${planId}/lesson`);
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}


async function saveMessages(data, navigate, showNotification) {
    try {
        return await instance.put('/writing/user-message', data, {
            headers: {
                'Content-type': 'application/json'
            }
        });
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function fetchWritingRoles(type, navigate, showNotification) {
    try {
        return await instance.get('/writing/role/list', { params: { type: type } });
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function fetchWord(word, navigate, showNotification) {
    try {
        return await instance.post('/word/translate', word, {
            headers: {
                'Content-type': 'application/json'
            }
        });
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function fetchAnalizeResult(data, navigate, showNotification) {
    try {
        return await instance.post('/writing/analyze', data, {
            headers: {
                'Content-type': 'application/json'
            }
        });
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function roundResult(result, navigate, showNotification) {
    try {
        return await instance.post('/vocabulary/round', result, {
            headers: {
                'Content-type': 'application/json'
            }
        });
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function smartCheck(wordExampleId, answer, navigate, showNotification) {
    try {
        return await instance.get('/vocabulary/smart', { params: { wordExampleId: wordExampleId, answer: answer } });
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function writingSmartCheck(textRu, answer, navigate, showNotification) {
    try {
        return await instance.get('/writing/translating/smart', { params: { textRu: textRu, answer: answer } });
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function grammarRoundResult(result, navigate, showNotification) {
    try {
        return await instance.post('/grammar/round', result, {
            headers: {
                'Content-type': 'application/json'
            }
        });
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function transcribeGrammarExercise(exerciseId, audio, navigate, showNotification) {
    try {
        const form = new FormData();
        form.append('file', audio);
        return await instance.post(`/grammar/exercises/${exerciseId}/speech/transcription`, form);
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function checkGrammarSituation(exerciseId, answer, navigate, showNotification) {
    try {
        return await instance.post(`/grammar/exercises/${exerciseId}/situation/check`, {answer}, {
            headers: {
                'Content-type': 'application/json'
            }
        });
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function signIn(data, navigate, showNotification) {
    try {
        return await instance.post('/auth/sign-in', data, {
            headers: {
                'Content-type': 'application/json'
            }
        });
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function logout(navigate, showNotification) {
    try {
        return await instance.post('/auth/logout');
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function signUp(data, navigate, showNotification) {
    try {
        return await instance.post('/auth/sign-up', data, {
            headers: {
                'Content-type': 'application/json'
            }
        });
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function sendMessage(data, navigate, showNotification) {
    try {
        return await instance.post('/writing/chat', data, {
            headers: {
                'Content-type': 'application/json'
            }
        });
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function getAllMessages(roleId, navigate, showNotification) {
    try {
        return await instance.get('/writing/translating/messages', { params: { roleId: roleId } });
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function getUserMessages(roleId, translating, navigate, showNotification) {
    try {
        return await instance.get('/writing/user-message', { params: { roleId: roleId, translating: translating } });
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function getRemindingWords(data, navigate, showNotification) {
    try {
        return await instance.post('/user-word/page', data, {
            headers: {
                'Content-type': 'application/json'
            }
        });
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function createSpeakingSession(data, navigate, showNotification) {
    try {
        return await instance.post('/speaking/sessions', data, {
            headers: {
                'Content-type': 'application/json'
            }
        });
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function getActiveSpeakingSession(roleId, navigate, showNotification) {
    try {
        return await instance.get('/speaking/sessions/active', {params: {roleId}});
    } catch (error) {
        // No session for a role is an expected state. The caller will create one.
        if (error.response?.status === 404) {
            return null;
        }
        return handleError(error, navigate, showNotification);
    }
}

async function getSpeakingMessages(sessionId, navigate, showNotification, page = 0, size = 50) {
    try {
        return await instance.get(`/speaking/sessions/${sessionId}/messages`, {params: {page, size}});
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function resetSpeakingSession(sessionId, navigate, showNotification) {
    try {
        return await instance.post(`/speaking/sessions/${sessionId}/reset`);
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function sendSpeakingTurn(sessionId, {audio, transcript, turnId}, navigate, showNotification) {
    try {
        const form = new FormData();
        form.append('audio', audio, 'voice.webm');
        form.append('transcript', transcript);
        return await instance.post(`/speaking/sessions/${sessionId}/messages`, form, {
            headers: {'Idempotency-Key': turnId}
        });
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function speech(audio, wordValue, navigate, showNotification) {
    try {
        const form = new FormData();
        form.append('file', audio);
        form.append('wordValue', wordValue);
        return await instance.post('/vocabulary/speech', form);
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function transcription(audio, navigate, showNotification) {
    try {
        const form = new FormData();
        form.append('file', audio);
        return await instance.post('/speaking/transcription', form);
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

async function fetchWaitTime(endpoint, navigate, showNotification, params) {
    try {
        return await instance.get(`${endpoint}/wait-time`, {params: params});
    } catch (error) {
        return handleError(error, navigate, showNotification);
    }
}

function handleError(error, navigate, showNotification) {
    // Network details stay in DevTools; learners only see a concise, actionable message.
    console.error('API request failed', error);
    if (error.response) {
        if (error.response.status === 403) {
            navigate('/login');
        } else if (error.response.data?.text) {
            showNotification(error.response.data.text);
        } else {
            showNotification('An unexpected error occurred');
        }
    } else {
        showNotification('An unexpected error occurred');
    }
}

function isValidResponse(response) {
    return response && response.status >= 200 && response.status < 300;
}
